/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tickets: NonNullable<unknown>, gross: NonNullable<unknown> }} Ticketssaleshintmoney3Inputs */

const en_ticketssaleshintmoney3 = /** @type {(inputs: Ticketssaleshintmoney3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} tickets · ${i?.gross}`)
};

const de_ticketssaleshintmoney3 = /** @type {(inputs: Ticketssaleshintmoney3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} Tickets · ${i?.gross}`)
};

/**
* | output |
* | --- |
* | "{tickets} tickets · {gross}" |
*
* @param {Ticketssaleshintmoney3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssaleshintmoney3 = /** @type {((inputs: Ticketssaleshintmoney3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssaleshintmoney3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssaleshintmoney3(inputs)
	return de_ticketssaleshintmoney3(inputs)
});
export { ticketssaleshintmoney3 as "ticketsSalesHintMoney" }